<template>
  <div>
    <div :class="{'card': isEdit}">
      <div :class="{'card-body mb-15': isEdit}">
        <div class="mb5"></div>
        <form class="form-horizontal" @onsubmit.prevent action>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" :class="{'has-error': validation.hasError('co_code')}">
                <label class="col-form-label">Select Company</label>
                <v-select
                  :options="companyList"
                  :placeholder="'Select Company'"
                  :label="'companyname'"
                  v-model="selComp"
                  @input="getCompDetails"
                >
                  <!-- <div class="spinner" v-show="spinner">Loading...</div> -->
                </v-select>
                <div class="error">{{ validation.firstError('co_code') }}</div>
              </div>
            </div>
          </div>
          <hr />
          <h4>Purchase Details</h4>
          <br />
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label class="form-control-label">Latest Price</label>
                <datepicker
                  :input-class="'form-control'"
                  :format="'dd-MM-yyyy'"
                  v-model="pdate"
                  disabled
                  :disabledDates="disabledDates"
                  @selected="getDateData($event, 1)"
                ></datepicker>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" :class="{'has-error': validation.hasError('latestPrice')}">
                <label class="form-control-label">Latest Price</label>
                <input type="hidden" class="form-control" v-model="pid" />
                <input type="hidden" class="form-control" v-model="co_code" />
                <input
                  type="text"
                  class="form-control inmarginbtm"
                  placeholder="Latest Price"
                  readonly
                  v-model="latestPrice"
                />
                <div class="error">{{ validation.firstError('latestPrice') }}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" :class="{'has-error': validation.hasError('totalAmount')}">
                <label class="form-control-label">Total Amount</label>
                <input
                  type="text"
                  class="form-control inmarginbtm"
                  placeholder="Enter total amount"
                  @blur="calculateNoOfShares(1)"
                  v-model="totalAmount"
                />
                <div class="error">{{ validation.firstError('totalAmount') }}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" :class="{'has-error': validation.hasError('noOfShares')}">
                <label class="form-control-label">No of shares</label>
                <input
                  type="text"
                  class="form-control inmarginbtm"
                  placeholder="Enter no of shares"
                  readonly
                  value
                  v-model="noOfShares"
                />
                <div class="error">{{ validation.firstError('noOfShares') }}</div>
              </div>
            </div>
          </div>
          <hr />
          <div class="row" v-if="companyDetails && companyDetails.latest_mcap">
            <div class="col-md-12">
              <label class="form-label col-md-2">
                <strong>Market Cap:</strong>
                <br />
                {{getFixed(companyDetails.latest_mcap)}}
              </label>
              <label class="form-label col-md-2">
                <strong>Industry Type:</strong>
                <br />
                {{getCustomLabel(companyDetails.market_type)}}
              </label>
              <label class="form-label col-md-2">
                <strong>Business Ratings:</strong>
                <br />
                {{getFixed(companyDetails.business_rating)}}
              </label>
              <label class="form-label col-md-2">
                <strong>Valuation Ratings:</strong>
                <br />
                {{getFixed(companyDetails.valuation_rating)}}
              </label>
              <label class="form-label col-md-2">
                <strong>Quarterly Ratings:</strong>
                <br />
                {{getFixed(companyDetails.p11_quarterly_trends_score_rating)}}
              </label>
            </div>
          </div>
          <hr />
          <h4>Sell Details</h4>
          <br />
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label class="form-control-label">Sell Date</label>
                <datepicker
                  :input-class="'form-control'"
                  :format="'dd-MM-yyyy'"
                  v-model="sdate"
                  disabled
                  :disabledDates="disabledDates"
                  :open-date="new Date()"
                  @selected="getDateData($event, 2)"
                ></datepicker>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" :class="{'has-error': validation.hasError('latestPrice')}">
                <label class="form-control-label">Sell Price</label>
                <input
                  type="text"
                  class="form-control inmarginbtm"
                  placeholder="Latest Price"
                  readonly
                  v-model="latestSalePrice"
                />
                <div class="error">{{ validation.firstError('latestSalePrice') }}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" :class="{'has-error': validation.hasError('noOfSharesSold')}">
                <label class="form-control-label">No of shares sold</label>
                <input
                  type="text"
                  class="form-control inmarginbtm"
                  placeholder="Enter no of shares"
                  v-model="noOfSharesSold"
                  @blur="calculateAmount(2)"
                />
                <div class="error">{{ validation.firstError('noOfSharesSold') }}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div
                class="form-group"
                :class="{'has-error': validation.hasError('totalAmountSold')}"
              >
                <label class="form-control-label">Total Amount of Sell</label>
                <input
                  type="text"
                  class="form-control inmarginbtm"
                  placeholder="Enter total amount"
                  v-model="totalAmountSold"
                  readonly
                />
                <div class="error">{{ validation.firstError('totalAmountSold') }}</div>
              </div>
            </div>
          </div>
          <div class="raw">
            <div class="col-md-12" v-if="errors && errors.length>0">{{errors}}</div>
          </div>
          <div class="form-group pull-right">
            <button type="button" @click="cancel" class="btn btn-default">Cancel</button>
          </div>&nbsp;&nbsp;
          <div class="form-group pull-right">
            <button
              type="button"
              @click="addPortfolio"
              class="btn btn-info"
            >{{isEdit? 'Update': 'Add'}}</button>
            <button
              type="button"
              @click="updatePortfolio"
              class="btn btn-info"
              v-if="portfolio"
            >Update</button>
          </div>
        </form>
        <div class="mb-15"></div>
        <div class="mb-15"></div>
      </div>
    </div>
  </div>
</template>
<script>
// import vform from "@/components/vform";
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import Datepicker from "vuejs-datepicker";
import SimpleVueValidation from "simple-vue-validator";
var Validator = SimpleVueValidation.Validator;
export default {
  name: "addStock",
  components: { Datepicker },
  mixins: [commonMixins],
  props: ["portfolio", "pid", "sid"],
  created() {
    // companiesListing / page / 1;
    this.getCompaniesList();
    console.log("existing", this.portfolio);
    if (!this.$route.params.id) {
      this.$router.push({ name: "portfolios" });
    }
    console.log(this.$route.name); // this.url.indexOf("user-activity")
    if (this.$route.name === "edit-stock") {
      this.isEdit = true;
      this.id = this.$route.params.id;
      this.pid = this.$route.params.sid;
      this.pname = this.$route.params.name;
      this.getStockDetails();
    } else if (this.$route.name === "portfolio-details") {
      this.isEdit = false;
      this.pid = this.$route.params.id;
    }
  },
  data() {
    return {
      isEdit: false,
      portfolioDetails: {},
      disabledDates: {
        to: new Date(Date.now() - 8640000),
        from: new Date()
      },
      pdate: new Date(),
      // pdate: new Date().setDate(new Date().getDate() - 1),
      // sdate: new Date().setDate(new Date().getDate() - 1),
      sdate: new Date(),
      co_code: "",
      latestPrice: "",
      latestSalePrice: "",
      totalAmount: "",
      noOfShares: "",
      totalAmountSold: "",
      noOfSharesSold: "",
      status: 1,
      errors: [],
      submitted: false,
      companyList: [],
      selComp: "",
      companyDetails: ""
    };
  },
  validators: {
    co_code: function(value) {
      return Validator.value(value).required();
    }
  },
  methods: {
    addPortfolio() {
      var _this = this;
      this.submitted = true;
      this.$validate().then(success => {
        // console.log('on success ' + success)
        if (success) {
          this.portfolioDetails = {
            _id: this.id ? this.id : "",
            portfolio_id: this.pid,
            co_code: this.co_code,
            companyname: this.selComp.companyname,
            no_of_share_purchased: this.noOfShares,
            price_per_share: this.latestPrice,
            date_of_purchase: this.getDate(this.pdate),
            no_of_share_sold: this.noOfSharesSold,
            price_at_which_sold: this.latestSalePrice,
            date_of_sale: this.getDate(this.sdate)
          };
          console.log("register details", this.portfolioDetails);
          http.post("addStockDetailsPortfolio", this.portfolioDetails, function(
            error,
            response
          ) {
            if (!error) {
              console.log("response", response);
              if (response.responseType === "Success") {
                _this.$toastr.success(response.message, "", {});
                _this.clearForm();
                if (!_this.isEdit) {
                  _this.$emit("submitForm", {
                    responseType: response.responseType
                  });
                } else {
                  _this.$router.push({
                    name: "portfolio-details",
                    params: { id: _this.pid, name: _this.pname }
                  });
                }
              } else {
                _this.errors = response.message;
              }
            } else {
              console.log("error", error);
            }
          });
        }
      });
    },
    clearForm() {
      this.portfolioDetails = {};
      (this.pdate = new Date()),
        (this.sdate = new Date()),
        (this.co_code = this.selComp.co_code),
        (this.latestPrice = ""),
        (this.latestSalePrice = ""),
        (this.totalAmount = ""),
        (this.noOfShares = ""),
        (this.totalAmountSold = ""),
        (this.noOfSharesSold = ""),
        (this.status = 1);
    },
    getCompaniesList() {
      let _this = this;
      http.get("getCompanyMaster", {}, function(error, response) {
        var companyList = response;
        if (companyList.length > 0) {
          _this.companyList = _this.sorted_fields_asc(
            companyList,
            "companyname"
          );
          _this.selComp =
            _this.selComp !== "" ? _this.selComp : _this.companyList[0];
          _this.co_code = _this.selComp.co_code;
          _this.getCompaniesPrice(_this.pdate, 1);
        }
      });
    },
    getCompaniesPrice(ddate, type) {
      var type = type;
      let _this = this;
      http.post(
        "getStockLatestPrice",
        { co_code: this.co_code, my_date: _this.getDate(ddate) },
        function(error, response) {
          // var price = response.latest_price;
          console.log(response);
          if (response) {
            _this.companyDetails = response;
            if (response.latest_price) {
              _this.latestSalePrice = response.latest_price;
              _this.latestPrice = response.latest_price;
              if (type === 1) {
                console.log("type", type);
                _this.latestPrice = response.latest_price;
                _this.calculateNoOfShares(type);
              } else if (type === 2) {
                _this.latestSalePrice = response.latest_price;
                _this.calculateNoOfShares(type);
              }
            }
          }
        }
      );
    },
    getCompDetails() {
      console.log("selected company", this.selComp, this.pdate);
      this.co_code = this.selComp.co_code;
      this.noOfShares = '';
      this.noOfSharesSold = '';
      this.totalAmountSold = '',
      this.totalAmount = '';
      // this.getCompaniesPrice();
      if (this.latestPrice !== "") {
        this.getCompaniesPrice(this.pdate, 1);
      }
      if (this.latestSalePrice !== "") {
        this.getCompaniesPrice(this.sdate, 2);
      }
    },
    getDateData(e, type) {
      console.log("Event ", type, e);
      console.log("Changed ", this.ddate);
      if (type === 1) {
        this.pdate = e;
        this.getCompaniesPrice(this.pdate, type);
      } else if (type === 2) {
        this.sdate = e;
        this.getCompaniesPrice(this.sdate, type);
      }
    },
    calculateNoOfShares(type) {
      if (type === 1 && this.totalAmount !== "") {
        this.noOfShares = Math.floor(this.totalAmount / this.latestPrice);
      } else if (type === 2 && this.totalAmountSold !== "") {
        this.noOfSharesSold = Math.floor(
          this.totalAmountSold / this.latestPrice
        );
      }
    },
    calculateAmount() {
      this.totalAmountSold = (this.latestPrice * this.noOfSharesSold).toFixed(4);
    },
    getStockDetails() {
      let _this = this;
      http.post(
        "getPortfolioStockDetails",
        { _id: this.id, portfolio_id: this.pid },
        function(error, response) {
          console.log(response);
          _this.selComp = {
            co_code: response[0].co_code,
            companyname: response[0].companyname
          };
          // this.id = value._id;
          // this.pid = value.portfolio_id;
          _this.latestPrice = response[0].price_per_share;
          _this.latestSalePrice = response[0].price_at_which_sold;
          _this.totalAmount = Math.round(
            parseInt(response[0].price_per_share) *
              parseInt(response[0].no_of_share_purchased)
          );
          _this.noOfShares = response[0].no_of_share_purchased;
          _this.totalAmountSold = Math.round(
            parseInt(response[0].no_of_share_sold) *
              parseInt(response[0].price_at_which_sold)
          );
          _this.noOfSharesSold = response[0].no_of_share_sold;
          let pdate = response[0].date_of_purchase.split("-");
          _this.pdate =
            pdate.length > 0
              ? new Date(pdate[1] + "-" + pdate[0] + "-" + pdate[2])
              : new Date();
          let sdate = response[0].date_of_sale.split("-");
          _this.sdate =
            sdate.length > 0
              ? new Date(sdate[1] + "-" + sdate[0] + "-" + sdate[2])
              : new Date();
        }
      );
    },
    cancel() {
      this.$router.push({
        name: "portfolio-details",
        params: { id: this.pid }
      });
    }
  },
  watch: {
    portfolio: function(value) {
      this.id = value._id;
      this.pid = value.portfolio_id;
      this.latestPrice = value.price_per_share;
      this.latestSalePrice = value.price_at_which_sold;
      this.totalAmount = value.price_per_share * value.no_of_share_purchased;
      this.noOfShares = value.no_of_share_purchased;
      this.totalAmountSold = value.no_of_share_sold * value.price_at_which_sold;
      this.noOfSharesSold = value.no_of_share_sold;
      this.pdate = this.getDate(value.date_of_purchase);
      this.sdate = this.getDate(value.date_of_sale);
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/portfolios/add-stock.vue